import { useCallback, useContext, useMemo, useState } from 'react';
import { Context as PurchaseTypeContext } from '@context/PurchaseTypeContext';
import { segment } from '@actions/analytics';
import { CHECKOUT_STARTED } from '@constants/segment';
import segmentStorage from '@events/segmentStorage';
import { evtNameCategoryMap } from '@constants/index';
import pushRoute from '@utils/pushRoute';

const usePageHead = ({ goalUID, isSubscribed, goalDetails, goalSlug }) => {
  const purchaseType = useContext(PurchaseTypeContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleSubscriptionClick = useCallback(() => {
    if (isSubscribed) {
      setIsDrawerOpen(true);
      return;
    }
    segment.track(
      CHECKOUT_STARTED,
      {
        goal_uid: goalUID,
        goal_name: goalDetails.name,
        is_subscription_active: false,
        is_upgrade: false,
        purchase_type: purchaseType,
        last_primary_source: segmentStorage.getItem('lps')
      },
      evtNameCategoryMap.BOTH
    );
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/subscribe',
      `/goal/${goalSlug}/${goalUID}/subscribe`,
      {},
      'goal'
    );
  }, [goalDetails, goalSlug, goalUID, isSubscribed, purchaseType]);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  return useMemo(
    () => ({
      handleSubscriptionClick,
      closeDrawer,
      isDrawerOpen
    }),
    [closeDrawer, handleSubscriptionClick, isDrawerOpen]
  );
};

export default usePageHead;
